import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EMPTY } from "rxjs";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { DataApi } from "../Model/dataApi";
import { MensajesHttpService } from "../utils/mensajesHttp/mensajes-http.service";
import { SeguridadService } from "./seguridad/seguridad.service";
import { ToastrServiceLocal } from "./toast/toastr.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  constructor(
    public router: Router,
    public seguridadService: SeguridadService,
    public _toast: ToastrServiceLocal,
    public _mensajesHttp: MensajesHttpService
  ) {}

  CerrarSesion() {
    localStorage.clear();
    this.router.navigateByUrl("inicio");
  }

  Login(params: any) {

    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', '');

    const request$ = this.seguridadService.PostDataApi(`auth/login`, params).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();
        localStorage.setItem("token", result.data.token);
        localStorage.setItem("menus", JSON.stringify(result.data.menus) );
        localStorage.setItem("usuario_data", JSON.stringify(result.data.informacionUsuario) );


        this.router.navigateByUrl('/dashboard');

        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al entrar al sistema', '');
        this.Cargando$.next(false);
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

 

  obtenerMenus() {
    return JSON.parse(localStorage.getItem("menusTotales"));
  }
}
